















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CompanyShowTabs extends Vue {
  get routeId() {
    return this.$route.params.id;
  }
}
